import React from 'react';

/**
 * Rotating chevron-down inside a rounded chip. Used inside expandable list
 * items such as `AEODiagnosticsChecklist` to indicate
 * open/closed state.
 */
export function ChevronIcon({ expanded }: { expanded: boolean }): React.ReactElement {
  return (
    <div
      className={`
        flex h-6 w-6 flex-shrink-0 items-center justify-center
        rounded-full bg-slate-100
        transition-transform duration-200
        ${expanded ? 'rotate-180' : ''}
      `}
    >
      <svg
        className="h-4 w-4 text-slate-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
      </svg>
    </div>
  );
}
